const crypto = require("crypto");
const axios = require("axios");
const genkeys = require("rezauthlib");
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});

export default {
  methods: {
    auto_enw_log() {
      // Check if current brand is in the env variable list
      const enwLogBrands = process.env.VUE_APP_ENW_LOG_BRANDS 
        ? JSON.parse(process.env.VUE_APP_ENW_LOG_BRANDS) 
        : [];
      
      if (enwLogBrands.includes(this.setbrandid)) {
        this.enw_log();
      }
    },
    
    enw_log() {
      // Generate a transaction token using a secure hash
      let chdata = process.env.VUE_APP_CHL + this.setbrandid.toLowerCase() + this.getLocalData("uuid");
      let hash = crypto.createHash("sha512");
      let transaction_token = hash.update(chdata, "utf-8").digest("hex");

      // Create request data with timestamp for freshness
      let datasearch = {
        uuid: this.getLocalData("uuid"),
        brand_id: this.setbrandid.toLowerCase(),
        orderreference: this.orderreference || "",
        transaction_token: transaction_token,
        timestamp: Date.now(), // Add timestamp for request freshness
      };

      // Get authentication keys
      let secsa = genkeys(
        process.env.VUE_APP_BRNDDET_SECRETID,
        process.env.VUE_APP_BRNDDET_SECRETKEY
      );

      // Add request ID for tracking and replay protection
      const requestId = Date.now().toString(36) + Math.random().toString(36).substr(2);

      // API endpoint
      let ur = "hubapmydbauth/live_alog/enw.php";

      // Make API request with security headers
      axios
        .post(process.env.VUE_APP_DOMAIN_DEVHUB + ur, datasearch, {
          headers: {
            b1: secsa.b1s,
            v2: secsa.v2s,
            c2s: secsa.c2s,
            a1: secsa.a1,
            v1: secsa.v1,
            c1: secsa.uidgen,
            "Content-Type": "application/json",
            "X-Request-ID": requestId,
          },
        })
        .then((response) => {
          // Validate response
          if (!response || !response.data) {
            console.error("Invalid response from server");
            return;
          }

          let data = response.data;

          // Store token securely with expiration
          if (data.user_exists === "Y" && data.data) {
            encryptStorage.setItem("enw_log_key", data.data);
            encryptStorage.setItem("mmb_link", data.mmb_link);
            this.logKey = encryptStorage.getItem("enw_log_key");
            if (this.updateHeader !== undefined) {
              this.updateHeader += 1;
            }
          }
        })
        .catch((error) => {
          console.error("Authentication error", error);
          // Don't log detailed error information
        });
    }
  }
};